import cookie from "cookiejs";
import axios from "./axios-report";

const TENANT_ID = "iam-m-invoice-react.v1.0.0_tenant";
const USER_NAME_STORAGE_KEY = "iam-m-invoice-react.v1.0.0_UserName";

const getExportUserName = (): string =>
  localStorage.getItem(USER_NAME_STORAGE_KEY) || "";

const IN_PROGRESS = 0;
const SUCCESS = 1;
const ERROR = 2;
const CANCELED = 3;

const INTEGRATED_REPORT = 1;
const INVOICE_DETAIL_REPORT = 2;
const INVOICE_SYNTHESIZE_REPORT = 4;
const USE_INVOICE_REPORT = 8;

const getCurrentJob = async () => {
  const api = `api/v2/export/job`;
  const res = await axios.get(api, {
    headers: {
      "X-Tenant-Id": localStorage.getItem(TENANT_ID),
    },
  });

  return res.data;
};

const loginJob = async () => {
  const api = `/api/auth/login`;
  const res = await axios.post(api, {
    tenantId: localStorage.getItem(TENANT_ID),
    userName: getExportUserName(),
  });
  if (res.data) {
    cookie.set("access_token_report", res.data.accessToken);
    cookie.set("refresh_token_report", res.data.refreshToken);
    cookie.set("refreshExpiredAt", res.data.refreshTokenExpiresAt);
  }
  return res.data;
};

const getMeJob = async () => {
  const api = `/api/auth/me`;
  const res = await axios.get(api);
  return res.data;
};

const createJob = async (type: number, params: Record<string, unknown>) => {
  const api = `api/v2/export/job`;
  const res = await axios.post(api, {
    type,
    params: {
      ...params,
      userName: getExportUserName(),
    },
  });
  return res.data;
};

const getDetailJobById = async (id: string) => {
  const api = `api/v2/export/job/${id}`;
  const res = await axios.get(api);
  return res.data;
};

const resumeJob = async (id: string) => {
  const api = `api/v2/export/job/${id}/resume`;
  const res = await axios.post(api);
  return res.data;
};

export {
  getExportUserName,
  getCurrentJob,
  createJob,
  loginJob,
  getMeJob,
  getDetailJobById,
  resumeJob,
  IN_PROGRESS,
  SUCCESS,
  ERROR,
  CANCELED,
  INTEGRATED_REPORT,
  INVOICE_DETAIL_REPORT,
  INVOICE_SYNTHESIZE_REPORT,
  USE_INVOICE_REPORT,
};
